import { ENV } from "./config/properties";

const app_apis = {
    getTranslations: {
        basePath: {
            env: {
                'DEV': 'http://previewdev.parker.com',
                'TEST': 'http://previewdev.parker.com',
                'STAGE': 'http://previewdev.parker.com',
                'PROD': 'http://preview.parker.com'
            }
        }, relativePath: '/TranslationRestAPI/Translation/getTranslations'
    },
    migrationAuthenticate: {
        basePath: {
            env: {
                'DEV': 'https://phdev.parker.com',
                'TEST': 'https://phtest.parker.com',
                'STAGE': 'https://phstage.parker.com',
                'PROD': 'https://cdnph.parker.com'
            }
        }, relativePath: '/wcs/resources/store/10151/loginidentity'
    },
    migrationUpdate: {
        basePath: {
            env: {
                'DEV': 'https://phdev.parker.com',
                'TEST': 'https://phtest.parker.com',
                'STAGE': 'https://phstage.parker.com',
                'PROD': 'https://cdnph.parker.com'
            }
        }, relativePath: '/wcs/resources/api/sso/user/update'
    },
    getTokenUrl: {
        basePath: {
            env: {
                'DEV': 'https://parkerexternal.oktapreview.com',
                'TEST': 'https://phqa.oktapreview.com',
                'STAGE': 'https://phstage.oktapreview.com',
                'PROD': 'https://parkerexternal.okta.com'
            }
        }, relativePath: '/api/v1/authn/recovery/token'
    },
    migrationFinish: {
        basePath: {
            env: {
                'DEV': 'https://oktatest-api.parker.com',
                'TEST': 'https://oktaqa-api.parker.com',
                'STAGE': 'https://oktastage-api.parker.com',
                'PROD': 'https://okta-api.parker.com'
            }
        }, relativePath: '/migration/finish'
    },
    changePassword: {
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/users'
    },
    addUserToGroup: {
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/groups/#groupid#/users/#userid#'
    },
    getPCMUrl: {
        basePath: {
            env: {
                'DEV': 'https://parkerexternal.oktapreview.com',
                'TEST': 'https://phqa.oktapreview.com',
                'STAGE': 'https://phstage.oktapreview.com',
                'PROD': 'https://parkerexternal.okta.com'
            }
        }, relativePath: '/api/v1/users/guid/groups'
    },
   
    
    getFooterUrl: {
        basePath: {
            env: {
                'DEV': 'https://phdev.parker.com',
                'TEST': 'https://phtest.parker.com',
                'STAGE': 'https://phstage.parker.com',
                'PROD': 'https://cdnph.parker.com'
            }
        }, relativePath: '/wcs/resources/store/22952/parkerheaderfooter/bysectiontype/Footer'
    },
    getRegisterUrl:{
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/users?activate=false'
    },
    getActivateUrl:{
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/users/#userGuid#/lifecycle/activate?sendEmail=false'
    },
    getUserDetails:{
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/users/'
    },
    getForgortPassword:{
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/users/#userGuid#/lifecycle/reset_password?sendEmail=false'
    },
    getJobsAPIUrl:{
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/smartcomm/api/v5/jobs'
    },
    getUsersFromGroup:{
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/groups/#groupid#/users'
    },
    getGroupsFromUser:{
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/users/#userid#/groups'
    },
    getAppInfo:{
        basePath: {
            env: {
                'DEV': 'https://apidev.parker.com/dev',
                'TEST': 'https://apidev.parker.com/test',
                'STAGE': 'https://api.parker.com/stage',
                'PROD': 'https://api.parker.com/prod'
            }
        }, relativePath: '/okta/apps/#appid#/'
    },
    getCurrentUser:{
        basePath: {
            env: {
                'DEV': 'https://logintest.parker.com',
                'TEST': 'https://loginqa.parker.com',
                'STAGE': 'https://loginstage.parker.com',
                'PROD': 'https://login.parker.com'
            }
        }, relativePath: '/api/v1/sessions/me'
    },
};

const app_paths = {
    redirectUrl: {
        basePath: {
            env: {
                'DEV': 'https://logintest.parker.com',
                'TEST': 'https://loginqa.parker.com',
                'STAGE': 'https://loginstage.parker.com',
                'PROD': 'https://login.parker.com'
            }
        }
    },
    redirectUrlTfs: {
        basePath: {
            env: {
                'DEV': 'https://logintest.totalfiltrationservices.com',
                'TEST': 'https://loginqa.totalfiltrationservices.com',
                'STAGE': 'https://loginstage.totalfiltrationservices.com',
                'PROD': 'https://login.totalfiltrationservices.com'
            }
        }
    },
    redirectUrlBaldwin: {
        basePath: {
            env: {
                'DEV': 'https://logintest.baldwinfilters.com',
                'TEST': 'https://loginqa.baldwinfilters.com',
                'STAGE': 'https://loginstage.baldwinfilters.com',
                'PROD': 'https://login.baldwinfilters.com'
            }
        }
    },
    getEmail: {
        basePath: {
            env: {
                'DEV': 'parkeraccount@logintest.parker.com',
                'TEST': 'parkeraccount@loginqa.parker.com',
                'STAGE': 'parkeraccount@loginstage.parker.com',
                'PROD': 'parkeraccount@login.parker.com'
            }
        }
    },
    getAuthorizationKey: {
        basePath: {
            env: {
                'DEV': 'QASecretKeyForMigrationPage',
                'TEST': 'QASecretKeyForMigrationPage',
                'STAGE': 'QASecretKeyForMigrationPage',
                'PROD': '7788KeyToInvokeMigrationService7788'
            }
        }
    },
    getTFSReqContext: {
        basePath: {
            env: {
                'DEV': 'https%3A%2F%2Fphdev.parker.com%2FSSOLoginPage%3FcatalogId%3D35151%26langId%3D-1%26SSOURL%3DaHR0cHM6Ly9waGRldi5wYXJrZXIuY29tL3Rmcy9lbi9NeUFjY291bnQ%253D%26storeId%3D22952',
                'TEST': 'https%3A%2F%2Fphtest.totalfiltrationservices.com%2FSSOLoginPage%3FcatalogId%3D35151%26langId%3D-1%26SSOURL%3DaHR0cHM6Ly9waHRlc3QudG90YWxmaWx0cmF0aW9uc2VydmljZXMuY29tL3Rmcy9lbi9NeUFjY291bnQ%253D%26storeId%3D22952',
                'STAGE': 'https%3A%2F%2Fphstage.totalfiltrationservices.com%2FSSOLoginPage%3FcatalogId%3D35151%26langId%3D-1%26SSOURL%3DaHR0cHM6Ly9waHN0YWdlLnRvdGFsZmlsdHJhdGlvbnNlcnZpY2VzLmNvbS90ZnMvZW4vTXlBY2NvdW50%26storeId%3D22952',
                'PROD': 'https%3A%2F%2Fph.totalfiltrationservices.com%2FSSOLoginPage%3FcatalogId%3D35151%26langId%3D-1%26SSOURL%3DaHR0cHM6Ly9waC50b3RhbGZpbHRyYXRpb25zZXJ2aWNlcy5jb20vdGZzL2VuL015QWNjb3VudA%253D%253D%26storeId%3D22952'
            }
        }
    },
    getPCMAuthorization: {
        basePath: {
            env: {
                'DEV': '00dDP4uPm7-E2ldz8oezdALU6DjyQHoBTn0YTNLs2F',
                'TEST': '00ve97yZkO4aJttsys54MXHsqppyDe6sxim2uiejIe',
                'STAGE': '00V9lUrePAn7DDFg9lg1iCD_yU926iWBWDcEV_iBg8',
                'PROD': '008QQM2RslO4Zdk9grf1OOwS3TXX6oBbPY_ZekEccR'
            }
        }
    },
    getTFSTnC:{
        basePath: {
            env: {
                'DEV': 'https://test.totalfiltrationservices.com/parkerimages/TFS/Terms%20and%20Privacy/Total%20Filtration%20Services%20TCs.pdf',
                'TEST': 'https://test.totalfiltrationservices.com/parkerimages/TFS/Terms%20and%20Privacy/Total%20Filtration%20Services%20TCs.pdf',
                'STAGE': 'https://test.totalfiltrationservices.com/parkerimages/TFS/Terms%20and%20Privacy/Total%20Filtration%20Services%20TCs.pdf',
                'PROD': 'https://test.totalfiltrationservices.com/parkerimages/TFS/Terms%20and%20Privacy/Total%20Filtration%20Services%20TCs.pdf'
            }
        }
    },
    getTFSPP:{
        basePath: {
            env: {
                'DEV': 'https://test.totalfiltrationservices.com/parkerimages/TFS/Terms%20and%20Privacy/Total%20Filtration%20Services%20PP.pdf',
                'TEST': 'https://test.totalfiltrationservices.com/parkerimages/TFS/Terms%20and%20Privacy/Total%20Filtration%20Services%20PP.pdf',
                'STAGE': 'https://test.totalfiltrationservices.com/parkerimages/TFS/Terms%20and%20Privacy/Total%20Filtration%20Services%20PP.pdf',
                'PROD': 'https://test.totalfiltrationservices.com/parkerimages/TFS/Terms%20and%20Privacy/Total%20Filtration%20Services%20PP.pdf'
            }
        }
    },
    getTnC:{
        basePath: {
            env: {
                'DEV': 'http://previewdev.parker.com/portal/site/PARKER/menuitem.9901ac95711d8c5906b58f95427ad1ca/?vgnextoid=1b487782259b6310VgnVCM10000014a71dacRCRD&vgnextchannel=2b4955b4d8876310VgnVCM10000014a71dacRCRD',
                'TEST': 'http://test.parker.com/portal/site/PARKER/menuitem.9901ac95711d8c5906b58f95427ad1ca/?vgnextoid=1b487782259b6310VgnVCM10000014a71dacRCRD&vgnextchannel=2b4955b4d8876310VgnVCM10000014a71dacRCRD',
                'STAGE': 'http://preview.parker.com/portal/site/PARKER/menuitem.9901ac95711d8c5906b58f95427ad1ca/?vgnextoid=1b487782259b6310VgnVCM10000014a71dacRCRD&vgnextchannel=2b4955b4d8876310VgnVCM10000014a71dacRCRD',
                'PROD': 'http://www.parker.com/portal/site/PARKER/menuitem.9901ac95711d8c5906b58f95427ad1ca/?vgnextoid=1b487782259b6310VgnVCM10000014a71dacRCRD&vgnextchannel=2b4955b4d8876310VgnVCM10000014a71dacRCRD'
            }
        }
    },
    getPP:{
        basePath: {
            env: {
                'DEV': 'http://previewdev.parker.com/portal/site/PARKER/menuitem.4450f18f18c082cdfd40eae8237ad1ca/?vgnextoid=760b904cf58b2110VgnVCM100000c9040d0aRCRD',
                'TEST': 'http://test.parker.com/portal/site/PARKER/menuitem.4450f18f18c082cdfd40eae8237ad1ca/?vgnextoid=760b904cf58b2110VgnVCM100000c9040d0aRCRD',
                'STAGE': 'http://preview.parker.com/portal/site/PARKER/menuitem.4450f18f18c082cdfd40eae8237ad1ca/?vgnextoid=760b904cf58b2110VgnVCM100000c9040d0aRCRD',
                'PROD': 'http://www.parker.com/portal/site/PARKER/menuitem.4450f18f18c082cdfd40eae8237ad1ca/?vgnextoid=760b904cf58b2110VgnVCM100000c9040d0aRCRD'
            }
        }
    },
    getParkerHomePage:{
        basePath: {
            env: {
                'DEV': 'https://dev.parker.com',
                'TEST': 'https://test.parker.com',
                'STAGE': 'https://preview.parker.com',
                'PROD': 'https://parker.com'
            }
        }
    },
    getTFSHomePage:{
        basePath: {
            env: {
                'DEV': 'https://dev.totalfiltrationservices.com',
                'TEST': 'https://test.totalfiltrationservices.com',
                'STAGE': 'https://preview.totalfiltrationservices.com',
                'PROD': 'https://totalfiltrationservices.com'
            }
        }
    },
    getBaldwinHomePage:{
        basePath: {
            env: {
                'DEV': 'https://dev.baldwinfilters.com',
                'TEST': 'https://test.baldwinfilters.com',
                'STAGE': 'https://preview.baldwinfilters.com',
                'PROD': 'https://baldwinfilters.com'
            }
        }
    },
    getTFSRedirectUrl:{
        basePath: {
            env: {
                'DEV': 'https://oktatest.parker.com',
                'TEST': 'https://oktaqa.totalfiltrationservices.com',
                'STAGE': 'https://oktaqa.totalfiltrationservices.com',
                'PROD': 'https://oktaqa.totalfiltrationservices.com'
            }
        }
    },
    getOCMSubscriptionKey:{
        basePath: {
            env: {
                'DEV': 'c4ed542738c740698cbf2c35eb3594d8',
                'TEST': '3582726943d84cdc9647533f5559058a',
                'STAGE': '',
                'PROD': ''
            }
        }
    },
    getJObAPIOCMSubscriptionKey:{
        basePath: {
            env: {
                'DEV': 'c926f915fa8f4305866ca03c51d98e6a',
                'TEST': '103366adaf444f879455e3cdaea053c9',
                'STAGE': '103366adaf444f879455e3cdaea053c9',
                'PROD': '103366adaf444f879455e3cdaea053c9'
            }
        }
    },
    getSmartCommQueue:{
        basePath: {
            env: {
                'DEV': 'Parker_Queue_DEV',
                'TEST': 'Parker_Queue_DEV',
                'STAGE': 'Parker_Queue_PROD',
                'PROD': 'Parker_Queue_PROD'
            }
        }
    },
    getPCMLinkURL:{
        basePath: {
            env: {
                'DEV': 'https://phc-pcm-dev-webapp.azurewebsites.net/login',
                'TEST': 'https://pcmtest.parker.com/login',
                'STAGE': 'https://pcmtest.parker.com/login',
                'PROD': 'https://pcmvom.parker.com/login'
            }
        }
    },
    getPhConnectUrl:{
        basePath: {
            env: {
                'DEV': 'https://phcdev.parker.corp',
                'TEST': 'https://phctest.parker.com',
                'STAGE': 'https://phctest.parker.com',
                'PROD': 'https://www.phconnect.com'
            }
        }
    },
    getParkerSSOUrl:{
        basePath: {
            env: {
                'DEV': 'https://logintest.parker.com/app/parkerhannifinsandboxapiparkerexternaloktapreview_parkercomwebspheretest_1/exkk0su8zubNYxDoD0h7/sso/saml',
                'TEST': 'https://loginqa.parker.com/app/phqa_parkercomwebsphereqa_1/exkofhhomyPE7XzaI0h7/sso/saml',
                'STAGE': 'https://loginqa.parker.com/app/phqa_parkercomwebsphereqa_1/exkofhhomyPE7XzaI0h7/sso/saml',
                'PROD': 'https://loginqa.parker.com/app/phqa_parkercomwebsphereqa_1/exkofhhomyPE7XzaI0h7/sso/saml'
            }
        }
    },
    getTFSSSOUrl:{
        basePath: {
            env: {
                'DEV': 'https://logintest.parker.com/app/parkerhannifinsandboxapiparkerexternaloktapreview_parkercomwebspheretest_1/exkk0su8zubNYxDoD0h7/sso/saml',
                'TEST': 'https://loginqa.parker.com/app/parkerhannifinqa_tfsicomwebsphereqa_1/exkoo014xrNamD6ML0h7/sso/saml',
                'STAGE': 'https://loginstage.parker.com/app/parkerhannifinstage_parkercomstage_1/exkororw2m2GkguhH0h7/sso/saml',
                'PROD': 'https://login.parker.com/app/parkerhannifinprodapiparkerexternal_parkercom_1/exk5cumgoisYcZ4rw2p7/sso/saml'
            }
        }
    },
    getBaldwinSSOUrl:{
        basePath: {
            env: {
                'DEV': 'https://logintest.parker.com/app/parkerexternal_baldwinfilterscomdev_1/exkv6igc0nacdRGxL0h7/sso/saml',
                'TEST': 'https://loginqa.parker.com/app/phqa_baldwinfilterscomqa_1/exkw4l90cobUATcR40h7/sso/saml',
                'STAGE': 'https://loginqa.parker.com/app/phqa_baldwinfilterscomqa_1/exkw4l90cobUATcR40h7/sso/saml',
                'PROD': 'https://loginqa.parker.com/app/phqa_baldwinfilterscomqa_1/exkw4l90cobUATcR40h7/sso/saml'
            }
        }
    },
    getTFS_HOME_SP_SSO_PAGE:{
        basePath: {
            env: {
                'DEV': 'https://phdev.parker.com/SSOLoginPage?storeId=22952&catalogId=35151&langId=-1&SSOURL=aHR0cHM6Ly9kZXYudG90YWxmaWx0cmF0aW9uc2VydmljZXMuY29t',
                'TEST': 'https://phtest.totalfiltrationservices.com/SSOLoginPage?storeId=22952&catalogId=35151&langId=-1&SSOURL=aHR0cHM6Ly90ZXN0LnRvdGFsZmlsdHJhdGlvbnNlcnZpY2VzLmNvbQ==',
                'STAGE': 'https://phtest.totalfiltrationservices.com/SSOLoginPage?storeId=22952&catalogId=35151&langId=-1&SSOURL=aHR0cHM6Ly90ZXN0LnRvdGFsZmlsdHJhdGlvbnNlcnZpY2VzLmNvbQ==',
                'PROD': 'https://phtest.totalfiltrationservices.com/SSOLoginPage?storeId=22952&catalogId=35151&langId=-1&SSOURL=aHR0cHM6Ly90ZXN0LnRvdGFsZmlsdHJhdGlvbnNlcnZpY2VzLmNvbQ=='
            }
        }
    },
    getBALDWIN_HOME_SP_SSO_PAGE:{
        basePath: {
            env: {
                'DEV': 'https://phdev.baldwinfilters.com/SSOLoginPage?storeId=22951&catalogId=34651&langId=-1&SSOURL=aHR0cHM6Ly9kZXYuYmFsZHdpbmZpbHRlcnMuY29tLw%3D%3D',
                'TEST': 'https://phtest.baldwinfilters.com/SSOLoginPage?storeId=22951&catalogId=34651&langId=-1&SSOURL=aHR0cHM6Ly90ZXN0LmJhbGR3aW5maWx0ZXJzLmNvbS8',
                'STAGE': 'https://phtest.parker.com/SSOLoginPage?storeId=23551&catalogId=14051&langId=-1&SSOMode=1',
                'PROD': 'https://phtest.parker.com/SSOLoginPage?storeId=23551&catalogId=14051&langId=-1&SSOMode=1'
            }
        }
    },
    getPARKER_HOME_SP_SSO_PAGE:{
        basePath: {
            env: {
                'DEV': 'https://phdev.parker.com/SSOLoginPage?storeId=23551&catalogId=14051&langId=-1&SSOMode=1',
                'TEST': 'https://phtest.parker.com/SSOLoginPage?storeId=23551&catalogId=14051&langId=-1&SSOMode=1',
                'STAGE': 'https://phstage.parker.com/SSOLoginPage?storeId=23551&catalogId=14051&langId=-1&SSOMode=1',
                'PROD': 'https://ph.parker.com/SSOLoginPage?storeId=23551&catalogId=14051&langId=-1&SSOMode=1'
            }
        }
    },
    getParkerGroupId:{
        basePath: {
            env: {
                'DEV': '00gmyc3zbdk0vCk5D0h7',
                'TEST': '00goin4rqa3Xz3j2h0h7',
                'STAGE': '00gorojvvt1DxzXzZ0h7',
                'PROD': '00g5cuhy5ymF74d6H2p7'
            }
        }
    },
    getTFSGroupId:{
        basePath: {
            env: {
                'DEV': '00gtbpzphlvScZhSF0h7',
                'TEST': '00gtbpzphlvScZhSF0h7',
                'STAGE': '00gtbpzphlvScZhSF0h7',
                'PROD': '00gtbpzphlvScZhSF0h7'
            }
        }
    },
    getBaldwinGroupId:{
        basePath: {
            env: {
                'DEV': '00gv6ihcb2nqrJG700h7',
                'TEST': '00gwezk0viZ3KU3Lx0h7',
                'STAGE': '00gwezkn20sMXvuar0h7',
                'PROD': '00g9lurdifIHhrQtC2p7'
            }
        }
    },
    getParkerIdAppId:{
        basePath: {
            env: {
                'DEV': '0oapybqrwpXwZsDaJ0h7',
                'TEST': '0oas6kmhniUQfOtrZ0h7',
                'STAGE': '0oasycxk91Nebr8gk0h7',
                'PROD': '0oa94tkck0cOJOVYl2p7'
            }
        }
    },
    getParkerIdApproverGroupId:{
        basePath: {
            env: {
                'DEV': '00guwe8k12MwvMXVz0h7',
                'TEST': '00gv2wspil6jxlNW80h7',
                'STAGE': '00gv2wtac0ZbuCPWI0h7',
                'PROD': '00g94tag83oO0Znsu2p7'
            }
        }
    },
    getParkerIdGroupId:{
        basePath: {
            env: {
                'DEV': '00guxbh2xuse4jnzx0h7',
                'TEST': '00gv2wsumjwEP0Aw60h7',
                'STAGE': '00gv2wurv6Y2nrDQt0h7',
                'PROD': '00g94tbh56Wbzeyod2p7'
            }
        }
    },
    getBaseReactUrl:{
        basePath: {
            env: {
                'DEV': 'https://oktatest.parker.com',
                'TEST': 'https://oktaqa.parker.com',
                'STAGE': 'https://oktastage.parker.com',
                'PROD': 'https://okta.parker.com'
            }
        }
    },
    getApproverClientID:{
        basePath: {
            env: {
                'DEV': '0oav58n0wnGNSfGC20h7',
                'TEST': '0oav5uydfpt1tBGBC0h7',
                'STAGE': '0oavltqgpzsTxXVfG0h7',
                'PROD': '0oa94tfmp2hCOyAAF2p7'
            }
        }
    },
}

export function getAPIUrl(api) {
    const envType = ENV;
    return app_apis[api].basePath["env"][envType] + app_apis[api]['relativePath'];
}

export function getPath(api) {
    const envType = ENV;
    return app_paths[api].basePath["env"][envType];
}